import { Component, ElementRef, ViewContainerRef, Renderer2, Injector, ChangeDetectionStrategy, QueryList, ValueProvider } from '@angular/core';
import { ComponentBase, ComponentMixins, IComponentBase, applyMixins, PropertyCollectionInfo, setValue } from '@syncfusion/ej2-angular-base';
import { ProgressButton } from '@syncfusion/ej2-splitbuttons';



export const /** @type {?} */ inputs: string[] = ['animationSettings','content','cssClass','disabled','duration','enableHtmlSanitizer','enableProgress','iconCss','iconPosition','isPrimary','isToggle','spinSettings'];
export const /** @type {?} */ outputs: string[] = ['begin','created','end','fail','progress'];
export const /** @type {?} */ twoWays: string[] = [];
/**
 * Represents the Angular ProgressButton Component.
 * ```html
 * <button ejs-progressbutton content='Progress Button'></button>
 * ```
 */
@ComponentMixins([ComponentBase])
export class ProgressButtonComponent extends ProgressButton implements IComponentBase {
public containerContext : any;
public tagObjects: any;
/**
 * @param {?} ngEle
 * @param {?} srenderer
 * @param {?} viewContainerRef
 * @param {?} injector
 */
constructor(private ngEle: ElementRef,
private srenderer: Renderer2,
private viewContainerRef:ViewContainerRef,
private injector: Injector) {
        super();
        this.element = this.ngEle.nativeElement;
        this.injectedModules = this.injectedModules || [];

        this.registerEvents(outputs);
        this.addTwoWay.call(this, twoWays);
        setValue('currentInstance', this, this.viewContainerRef);
        this.containerContext  = new ComponentBase();
    }
/**
 * @return {?}
 */
public ngOnInit() {
        this.containerContext.ngOnInit(this);
    }
/**
 * @return {?}
 */
public ngAfterViewInit(): void {
        this.containerContext.ngAfterViewInit(this);
    }
/**
 * @return {?}
 */
public ngOnDestroy(): void {
        this.containerContext.ngOnDestroy(this);
    }
/**
 * @return {?}
 */
public ngAfterContentChecked(): void {
        
        this.containerContext.ngAfterContentChecked(this);
    }
public registerEvents: (eventList: string[]) => void;
public addTwoWay: (propList: string[]) => void;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: '[ejs-progressbutton]',
    inputs: inputs,
    outputs: outputs,
    template: `<ng-content ></ng-content>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    queries: {

    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: ViewContainerRef, },
{type: Injector, },
];
}

function ProgressButtonComponent_tsickle_Closure_declarations() {
/** @type {?} */
ProgressButtonComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProgressButtonComponent.ctorParameters;
/** @type {?} */
ProgressButtonComponent.prototype.containerContext;
/** @type {?} */
ProgressButtonComponent.prototype.tagObjects;
/** @type {?} */
ProgressButtonComponent.prototype.registerEvents;
/** @type {?} */
ProgressButtonComponent.prototype.addTwoWay;
/** @type {?} */
ProgressButtonComponent.prototype.ngEle;
/** @type {?} */
ProgressButtonComponent.prototype.srenderer;
/** @type {?} */
ProgressButtonComponent.prototype.viewContainerRef;
/** @type {?} */
ProgressButtonComponent.prototype.injector;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
